import type { ReactElement } from "react";

type HeaderNoLinksProps = {
  homeHref: string;
};

// When links are ready to return, review HeaderWithLinks and either use it directly
// or use it as inspiration for the appropriate navigation experience.
export function HeaderNoLinks({ homeHref }: HeaderNoLinksProps): ReactElement {
  return <header className="site-header site-header-no-links">
    <a href={homeHref} className="brand" aria-label="MotionTwist home"><img src="/assets/motiontwist-logo.png" alt=""/><span><b>Motion</b><em>Twist</em><small>Turn products into motion</small></span></a>
  </header>;
}
